const Feed_back ={
    Emoji1:"./Images/Feedback/emoji1.png",
    Emoji2 :"./Images/Feedback/emoji2.png",
    Emoji3:"./Images/Feedback/emoji3.png",
    Emoji4:"./Images/Feedback/emoji4.png",
    Emoji5:"./Images/Feedback/emoji5.png"

}
export default Feed_back;